import React from 'react';
import { Icon } from '@material-ui/core';

/**
 * Why a dropdown option cannot be picked ("Not offered in us-east-1e", "x86 shape,
 * image is arm64", "Never built"), shown inline on the option.
 *
 * Inline rather than a tooltip, because a disabled option ignores the pointer. Neutral
 * rather than red, because an unavailable choice is not an error. Pickers fade the rest
 * of a disabled option with DIMMED and leave this at full strength, since it is the part
 * of that row the user has to read.
 */
export const DIMMED = { opacity: 0.5 };

const reasonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    maxWidth: 300,
    // px, not rem: the app's root font size is 10px, so rem units come out tiny here.
    fontSize: 13,
    lineHeight: 1.35,
    color: '#475569',
    whiteSpace: 'normal',
};

export default function UnavailableReason({ reason }) {
    if (!reason) return null;
    return (
        <span style={reasonStyle}>
            <Icon style={{ fontSize: 16, color: '#94a3b8' }} aria-hidden="true">block</Icon>
            {reason}
        </span>
    );
}
